const ModuleItems =
  "... on LessonItem { __typename id name presentationId  } ... on Quiz { __typename id name } ... on RecallItem { __typename id name } ... on FlashcardItem { __typename id name }";

export const CourseResult = `{ id name access description thumbnailURL author tags map { id courseItems { ... on CourseModule { __typename id name items { ${ModuleItems} } } ${ModuleItems} } presentations { id type name videos { duration } }} }`;

export const CourseQuery = `{ courses ${CourseResult}}`;
